import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';
import { Repository, State } from '@frontend-site/shared/utils';

export interface NavigationState extends State {
    navigationIds: {
        id: number;
        typeId: number;
        projectId?: number;
    }[];
    indexToId?: any[];
    currentId?: number;
    currentProjectId?: number;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationStore extends Repository<NavigationState> {
    navigationState$ = this.store.pipe(select((state) => state));
    indexToId$ = this.store.pipe(select((state) => state.indexToId));

    constructor() {
        super(
            createStore(
                { name: 'entitiesNavigation' },
                withProps<NavigationState>({ navigationIds: [], indexToId: [], currentId: undefined })
            )
        );
    }

    updateNavigationIds(navigationIds: NavigationState['navigationIds']) {
        this.update({ navigationIds });
    }

    updateIndexToId(indexToId: NavigationState['indexToId']) {
        this.update({ indexToId });
    }

    updateCurrentId(currentId: NavigationState['currentId'], currentProjectId?: NavigationState['currentProjectId']) {
        this.update({ currentId, currentProjectId });
    }

    getNavigationState() {
        return this.getValue();
    }
}
